import { connect } from 'react-redux'
import { logout } from '../actions/users'
import Logout from '../components/Logout'

export default connect(null, { logout })(Logout)
